// @flow
import React, { Fragment } from 'react';
import i18n from 'i18n-js';

import styles from '../../StudentCard/StudentDataPanel/studentDataPanel.css';
import type { PARENT_TYPE } from '../../../types/parents';
import Cell from '../../DataTable/Cells/Text';

type ParentDataPanelPropTypes = {
  parent: PARENT_TYPE,
  updateParent: Function,
}; 

const ParentDataPanel = ({
  parent = {},
  updateParent,
}: ParentDataPanelPropTypes) => {
  let phoneSplited = "";
  if (parent.user) {
    phoneSplited = parent.user.phone.split("+502")[1];
  };

  return (
    <Fragment>
      <p className={styles.label}>{i18n.t('labels.name', { count: 1 })}</p>
      <div className={styles.data}>
        <Cell
          value={
            `${parent && parent.user.first_name}`
          }
          editable
          original={parent}
          onChange={(original, first_name) => updateParent({ id: original.id, first_name })}
        />
      </div>
      <p className={styles.label}>{i18n.t('labels.lastName', { count: 1 })}</p>
      <div className={styles.data}>
        <Cell
          value={
            `${parent && parent.user.last_name}`
          }
          editable
          original={parent}
          onChange={(original, last_name) => updateParent({ id: original.id, last_name })}
        />
      </div>
      <br />
      <p className={styles.label}>{i18n.t('labels.phone')}</p>
      <div className={styles.data}>
        <Cell
          value={phoneSplited}
          editable
          original={parent}
          onChange={(original, phone) => updateParent({ id: original.id, phone })}
        />
      </div>
      <p className={styles.label}>Email: </p>
      <div className={styles.data}>
        <Cell
          value={
            `${parent && parent.user && parent.user.email}`
          }
          editable
          original={parent}
          onChange={(original, email) => updateParent({ id: original.id, email })}
        />
      </div>

      <p className={styles.label}>Dirección: </p>
      <div className={styles.data}>
        <Cell
          value={
            `${parent && parent.address}`
          }
          editable
          original={parent}
          onChange={(original, address) => updateParent({ id: original.id, address })}
        />
      </div>
    </Fragment>
  )
};

export default ParentDataPanel;



// WEBPACK FOOTER //
// ./src/scripts/components/ParentCard/ParentDataPanel/index.jsx